module.exports = __webpack_public_path__ + "img/success.f74278f4.svg";